module.exports = "<app-dropdown [state]=\"state\"> <app-dropdown-button [state]=\"state\">{{ current | uppercase }}</app-dropdown-button> <app-dropdown-content> <ul class=\"gutter\"> <li *ngFor=\"let option of options\"> <span class=\"hoverable\" (click)=\"select(option.value)\">{{ option.name }}</span> </li> </ul> </app-dropdown-content> </app-dropdown> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/select/select.component.html
// module id = ./src/app/shared/components/select/select.component.html
// module chunks = 21